<div class="card detail">
  <div class="card-body">
    <div class="title d-flex justify-content-between">
      <div class="d-flex flex-column justify-content-between">
        <h3 class="card-title">{{ "Projects" | translate }}</h3>
      </div>
      <div
        *ngIf="isAdmin && currLocation && !currLocation.id"
        class="action-btn"
      >
        <a
          class="btn btn-sm btn-circle btn-outline-primary"
          [routerLink]="['projects', 'create']"
        >
          <i class="icon-create"></i>
        </a>
      </div>
    </div>
    <div class="title d-flex justify-content-between">
      <button
        (click)="toggleIsSearch(true)"
        [ngClass]="{ 'btn-primary': isSearch, 'btn-light': !isSearch }"
        class="btn btn-sm btn-options"
      >
        {{ "Search" | translate }}
      </button>
      <button
        (click)="toggleIsSearch(false)"
        [ngClass]="{ 'btn-primary': !isSearch, 'btn-light': isSearch }"
        class="btn btn-sm btn-options"
        [disabled]="!hasLoaded"
      >
        {{ "Filter" | translate }}
      </button>
    </div>
    <div
      class="mt-2"
      #listContainer
      (mouseenter)="onComponentHover(true, $event)"
      (mouseleave)="onComponentHover(false, $event)"
      style="display: flex; flex-flow: column; width: 100%; height: 600px"
    >
      <ng-container *ngIf="isSearch; else filter">
        <ng-container *ngTemplateOutlet="search"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #search>
  <div style="display: flex; flex-flow: column; height: 100%; overflow: auto">
    <div style="display: flex">
      <div class="input-group">
        <input
          #searchTextBox
          class="form-control"
          (focus)="onSearchFocused(true, $event)"
          (blur)="onSearchFocused(false, $event)"
          [ngModel]="searchObj.searchValue"
          (ngModelChange)="onSearchChange($event)"
          type="text"
          data-cy="project-search"
        />
        <!-- <button disabled class="btn btn-sm"><i class="icon-search"></i></button> -->
        <div class="input-group-append" *ngIf="showPinButton">
          <button
            class="btn btn-primary btn-sm"
            type="button"
            (click)="centerToCoordinate()"
          >
            <i class="icon-pointer"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="mt-2" style="display: flex;">
      <button *ngFor="let type of searchObj.searchTypes" class="btn btn-sm btn-light mr-2"
        [ngClass]="{'btn-darker-light': searchObj.currentType === type }" (click)="onTypeChange(type)">{{type}}</button>
    </div> -->
    <div
      class="mt-2"
      *ngIf="searchObj.isSearchOpen"
      data-cy="project-search-list"
      style="flex-flow: column; overflow: auto"
    >
      <div *ngFor="let loc of searchObj.searchRes; trackById">
        <!-- <ng-container *ngTemplateOutlet="card; context: { data: loc }"></ng-container> -->
        <app-card-project *ngIf="loc" [data]="loc"></app-card-project>
      </div>
    </div>
    <ul *ngIf="!searchObj.isSearchOpen" class="list-group mt-2 project-list">
      <ng-container *ngIf="true">
        <p class="text-muted" *ngIf="currLocation && !currLocation.id">
          {{ "All facilities" | translate }}
        </p>
        <p *ngIf="currLocation && currLocation.id && !currLocation.parent">
          <a routerLink="/projects">{{ "All facilities" | translate }}</a> /
          <span class="text-muted">{{ currLocation.name }}</span>
        </p>
        <p *ngIf="currLocation && currLocation.id && currLocation.parent">
          <a
            [routerLink]="[
              '/projects',
              currLocation.parent.id,
              'details',
              'summary'
            ]"
            >{{ currLocation.parent.name }}</a
          >
          / <span class="text-muted">{{ currLocation.name }}</span>
        </p>
      </ng-container>
      <li class="list-group-item" *ngIf="projects?.length === 0">
        <div class="card inner-shadow">
          <div class="card-body">{{ "No Project" | translate }}</div>
        </div>
      </li>
      <li class="list-group-item">
        <div *ngFor="let project of projects; trackById">
          <app-card-project [data]="project"></app-card-project>
        </div>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #filter>
  <div
    *ngIf="
      annotations?.location_component?.length > 1 ||
      annotations?.annotation_type?.length > 1 ||
      annotations?.severity_type?.length > 1
    "
  >
    <ul class="filter-list list-group" style="border-bottom: 0px">
      <!-- <ng-container *ngIf="annotations?.location_component?.length > 1">
        <p class="text-left mb-2 font-weight-bold">{{ 'Components' | translate }}</p>
        <li class="list-group-item" *ngFor="let item of annotations.location_component">
          <div class="toggle-container">
            <app-toggle-switch [selected]="componentFilter.includes(item.id)"
              (change)="toggleAnnotationBy('location_component', item.id)"></app-toggle-switch>
            <p>{{ item.name | translate }}</p>
          </div>
        </li>
      </ng-container> -->

      <ng-container *ngIf="annotations?.annotation_type?.length > 0">
        <p class="text-left mb-2 font-weight-bold">
          {{ "Defect Type" | translate }}
        </p>
        <li
          class="list-group-item"
          *ngFor="let item of annotations.annotation_type; trackById"
        >
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="defectFilter.includes(item.id)"
              (change)="toggleAnnotationBy('annotation_type', item.id)"
            ></app-toggle-switch>
            <p>{{ item.name | translate }}</p>
          </div>
        </li>
      </ng-container>

      <ng-container *ngIf="annotations?.severity_type?.length > 0">
        <p class="text-left mb-2 font-weight-bold">
          {{ "Severity" | translate }}
        </p>
        <li
          class="list-group-item"
          *ngFor="let item of annotations.severity_type; trackById"
        >
          <div class="toggle-container">
            <app-toggle-switch
              [selected]="severityFilter.includes(item.id)"
              (change)="toggleAnnotationBy('severity_type', item.id)"
            ></app-toggle-switch>
            <p>{{ item.name | translate }}</p>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
  <div
    *ngIf="currLocation?.id"
    class="d-flex justify-content-end mt-3"
    style="width: 100%"
  >
    <div (click)="genFilteredReport()" class="btn btn-primary btn-sm">
      {{ "Get Filtered Report" | translate }}
    </div>
  </div>
</ng-template>

<ng-template #card let-data="data">
  <!--  id will be changed to project{{id}} to enable insertion of additional classes-->
  <div
    class="project-card extend-details"
    [id]="'project-card-' + data.id"
    [class.show]="searchObj.isOpen[data.id]"
    (mouseenter)="toggleCard(data.id, true)"
    (mouseleave)="toggleCard(data.id, false)"
  >
    <div class="d-flex w-100">
      <div class="details">
        <p class="title text-left">{{ data.name }}</p>
        <div class="hide-before">
          <!-- <p class="name">{{data.description}}</p> -->
          <p class="coordinates">
            {{ data.coordinate[0] | number }}, {{ data.coordinate[1] | number }}
          </p>
          <!-- <div class="space">
                <p class="damages">ダメージ : 10</p>
                <p class="inspections">検査 : 2</p>
                <p class="inspected">検査された資産 : 3</p>
            </div> -->
        </div>
        <div class="space">
          <p class="name">{{ data.description }}</p>
          <p class="date">{{ data.created_at | date: "yyyy / M / d" }}</p>
        </div>
      </div>
      <!-- <div class="severities"> -->
      <!-- below is dynamic approach -->
      <!-- <div class="severities-container" *ngFor="let sc of _formattedSeverityCount">
            <div [style.backgroundColor]="i.color" *ngFor="let i of sc">{{i.value}}</div> -->
      <!-- <div [class]="getBgColor(i.severity_level)" *ngFor="let i of sc">{{i.value}}</div> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>
    <div class="hide-before pt-2">
      <div class="buttons">
        <button
          class="btn btn-sm btn-secondary"
          [id]="'mapbox-center-' + data.id"
          (click)="$event.stopPropagation(); center(data)"
        >
          {{ "Center" | translate }}
        </button>
        <button
          class="btn btn-sm btn-primary"
          (click)="$event.stopPropagation(); redirect(data)"
        >
          {{ "Enter" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
